import { Flex } from "antd";
import Button from "../../../Helpers/Button/Button";
import { CiHeadphones, CiMicrophoneOn, CiPlay1, CiStop1 } from "react-icons/ci";
import VehicleSelect from "./VehicleSelect";

export default function LivestreamHeader({
  setLayoutType,
  setIsPlaying,
  layoutType,
  vehicles,
  feeds,
  setSelectedFeeds,
  selectedValues,
  isLoading,
}) {
  return (
    <>
      <div className="bg-white p-16">
        <Flex vertical={false} justify="space-between" gap={80}>
          <Flex vertical={false} style={{ flex: 1 }}>
            <VehicleSelect
              maxCount={layoutType}
              vehicles={vehicles}
              feeds={feeds}
              setSelectedFeeds={setSelectedFeeds}
              selectedValues={selectedValues}
              isLoading={isLoading}
            />
          </Flex>
          <Flex vertical={false} gap="small">
            <Button
              icon={<CiPlay1 size={25} />}
              type={"default"}
              tooltip={"Play"}
              onClick={() => setIsPlaying(true)}
            />
            <Button
              icon={<CiStop1 size={25} />}
              type={"default"}
              tooltip={"Stop"}
              onClick={() => setIsPlaying(false)}
            />
            <Button
              icon={<CiMicrophoneOn size={25} />}
              type={"default"}
              tooltip={"Intercom"}
            />
            <Button
              icon={<CiHeadphones size={25} />}
              type={"default"}
              tooltip={"Monitor"}
            />
          </Flex>
          <Flex vertical={false} gap={"small"}>
            <Button
              onClick={() => setLayoutType(1)}
              // icon={<CiGrid41 size={25} />}
              type={"default"}
              text={"1 cam"}
            />
            <Button
              onClick={() => setLayoutType(2)}
              // icon={<CiGrid41 size={25} />}
              type={"default"}
              text={"4 cams"}
            />
            <Button
              onClick={() => setLayoutType(3)}
              // icon={<CiGrid41 size={25} />}
              type={"default"}
              text={"6 cams"}
            />
            <Button
              onClick={() => setLayoutType(5)}
              // icon={<CiGrid41 size={25} />}
              type={"default"}
              text={"8 cams"}
            />
            <Button
              onClick={() => setLayoutType(4)}
              // icon={<CiGrid41 size={25} />}
              type={"default"}
              text={"9 cams"}
            />
          </Flex>
        </Flex>
      </div>
    </>
  );
}
